import { useEffect } from "react";
import queryString from "query-string";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import keys from "lodash/fp/keys";
import mapValues from "lodash/fp/mapValues";
import merge from "lodash/fp/merge";
import omit from "lodash/fp/omit";

function setQueryString(window) {
  return (qs) => {
    const {
      location: { origin, pathname, hash },
      history,
    } = window;
    history.pushState(
      null,
      "",
      origin + pathname + (qs.length > 0 ? "?" + qs : "") + hash
    );
  };
}

export const queryStringStringifyWithOptions = (obj) =>
  queryString.stringify(obj, { skipEmptyString: true, skipNull: true });

export const queryStringParse = flow(
  queryString.parse,
  mapValues((v) => (v === "true" || v === "false" ? v === "true" : v))
);

export default function useSetQueryString(queryParams = {}) {
  useEffect(() => {
    flow(
      getOr("", ["location", "search"]),
      queryStringParse,
      (q) => merge(q)(queryParams),
      queryStringStringifyWithOptions,
      setQueryString(window)
    )(window);

    return () => {
      flow(
        getOr("", ["location", "search"]),
        queryStringParse,
        omit(keys(queryParams)),
        queryStringStringifyWithOptions,
        setQueryString(window)
      )(window);
    };
  }, [JSON.stringify(queryParams)]);
}
